import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import store from "./store/store";
import { Provider } from "react-redux";
import AuthenticationPortal from "./authentication/AuthenticationPortal";

function App() {
  const [token, setToken] = useState();
  const [_style, setStyle] = useState({
    minHeight: "100vh",
    background: "#cff8ff",
    marginTop: "0px",
  });
  const isLandscape = () =>
      window.matchMedia("(orientation:landscape)").matches,
    [orientation, setOrientation] = useState(
      isLandscape() ? "landscape" : "portrait"
    ),
    onWindowResize = () => {
      clearTimeout(window.resizeLag);
      window.resizeLag = setTimeout(() => {
        delete window.resizeLag;
        setOrientation(isLandscape() ? "landscape" : "portrait");
      }, 200);
    };

  useEffect(
    () => (
      onWindowResize(),
      window.addEventListener("resize", onWindowResize),
      () => window.removeEventListener("resize", onWindowResize)
    ),
    []
  );

  return (
    <div
      style={{
        ..._style,
      }}
    >
      <Provider store={store}>
        <AuthenticationPortal orientation={orientation} setToken={setToken} />
      </Provider>
    </div>
  );
}

export default App;
